import React from "react";

import Image from "../../../components/image";
import { useTheme } from "../../../context/ThemeContext";
import TickIcon from "../../../images/icons/tick-dark.inline.svg";
import RichmondLightBg from "../../../images/richmond_bg_people.jpeg";
import RichmondDarkBg from "../../../images/richmond_bg_planet.jpeg";

const Careers = ({ careers, internshipType, benefits }) => {
  const { colorMode } = useTheme();

  // console.log("careers", benefits);
  return (
    <>
      <h2
        className="heading text-left py-5"
        dangerouslySetInnerHTML={{
          __html: careers?.careersTitleInternships || ""
        }}
      />
      <div className="divide-y width-divider" />
      <div
        className="planet:gvi-light-gray-text  text-black-lighter text-sm pt-5 tab-content_html"
        dangerouslySetInnerHTML={{
          __html: careers.careersDescriptionInternships
        }}
      />
      <h2
        className="heading text-left py-10"
        dangerouslySetInnerHTML={{ __html: benefits?.title || "" }}
      />
      <div className="grid grid-cols-none sm:grid-cols-2 gap-4 py-3">
        {benefits?.items?.map((benefit, idx) => (
          <div
            key={`benefit-${idx}`}
            className="bg-gray-lighten planet:gvi-light-gray-bg p-4 w-full h-full rounded-xs relative"
          >
            <div className="flex bg-gray-lighten planet:bg-transparent w-full justify-start">
              <div className="pt-4">
                <TickIcon className="w-4 h-4 stroke-black-lighter planet:stroke-white" />
              </div>
              <h3
                className="font-normal text-base flex leading-[23px] pt-3 pl-2"
                dangerouslySetInnerHTML={{ __html: benefit?.title || "" }}
              />
            </div>

            <div className="commitment-heading">
              <h3
                className="font-semibold !text-gray-lighter text-sm py-3"
                dangerouslySetInnerHTML={{
                  __html: benefit?.description || ""
                }}
              />
            </div>
          </div>
        ))}
      </div>
      <div
        className="flex flex-col rounded-md py-2 px-5 bg-center bg-cover border-none planet:!border-2 planet:border-gray-generic"
        style={{
          backgroundImage: `url(${
            colorMode === "light" ? RichmondLightBg : RichmondDarkBg
          })`
        }}
      >
        <div className="flex flex-col md:flex-row items-center justify-between py-2 sm:pl-2 sm:pr-2">
          <div className="w-full sm:w-3/4 h-full sm:pr-6 pt-0 sm:pt-4 pb-4 sm:pb-0">
            <h3
              className="font-bold text-base sm:text-base text-center sm:text-left planet:text-gray-generic !text-white"
              dangerouslySetInnerHTML={{
                __html: careers?.schoolTitleInternships || ""
              }}
            />
          </div>

          <Image
            imageClass={"object-cover rounded-md w-1/2"}
            imageAlt={""}
            // image={careers.schoolLogoInternships?.gatsbyImage}
            image={""}
            sourceUrl={careers?.schoolLogoInternships?.sourceUrl}
          />
        </div>
      </div>
      {internshipType === "Apprenticeship" && (
        <>
          <div className="divide-y width-divider sm:width-divider mt-10 sm:mt-0" />

          <h2 className="heading text-left py-10">
            {careers?.careerGuaranteeTitleInternships || ""}
          </h2>
          <div
            className="font-normal !text-gray-generic text-base py-6"
            dangerouslySetInnerHTML={{
              __html: careers?.careerGuaranteeDescriptionInternships || ""
            }}
          />

          <Image
            imageClass="w-full rounded"
            imageAlt={""}
            // image={careers.careerGuaranteeImageInternships?.gatsbyImage}
            image={""}
            sourceUrl={careers?.careerGuaranteeImageInternships?.sourceUrl}
          />
        </>
      )}
    </>
  );
};

export default Careers;
